import sdgsService from "../../services/sdgsService/service";
import SdgsModel from "../../models/sdgsModel/model";
export default {
    async fetchSdgs(search, page,limit, company){
        try{
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const {data, headers} = await sdgsService.getSdgs(sanitizedSearch, page, limit, company);
            return {
                data: data.map(sdgs => new SdgsModel(sdgs)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            }
        } catch (error) {
            console.error('Error fetching sdgs:', error);
            throw error;
        }
    },
    async totalAllSdgs(company){
        try {
            return await sdgsService.totalAllSdgs(company);
        } catch (error) {
            console.error('Error fetching sdgs:', error);
            throw error;
        }
    },
    async addSdgs(sdgs){
        try {
            return await sdgsService.addSdgs(sdgs);
        } catch (error) {
            console.error('Error adding sdgs:', error);
            throw error;
        }
    },
    async updateSdgs(sdgs){
        try {
            return await sdgsService.updateSdgs(sdgs);
        } catch (error) {
            console.error('Error updating sdgs:', error);
            throw error;
        }
    },
    async deleteSdgs(sdgsId, sdgs){
        try {
            return await sdgsService.deleteSdgs(sdgsId, sdgs);
        } catch (error) {
            console.error('Error deleting sdgs:', error);
            throw error;
        }
    },
}